import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  // Témoignages de clients
  const testimonials = [
    {
      id: 1,
      name: 'Sophie L.',
      content: 'Les consultations de naturopathie ont transformé ma relation avec mon corps. Après des années de problèmes digestifs, j\'ai enfin trouvé un équilibre grâce aux conseils personnalisés.',
      rating: 5
    },
    {
      id: 2,
      name: 'Marc D.',
      content: 'Approche professionnelle et bienveillante. J\'ai particulièrement apprécié le suivi après la consultation principale et les ajustements progressifs de mon programme.',
      rating: 5
    },
    {
      id: 3,
      name: 'Isabelle M.',
      content: 'Les Fleurs de Bach ont eu un effet extraordinaire sur mon stress chronique. Je dors mieux et me sens plus sereine au quotidien.',
      rating: 4
    }
  ];


  return (
    <div className="home-page">
      {/* Section Hero */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1>Retrouvez votre équilibre naturel</h1>
            <p>
              Consultations de naturopathie personnalisées pour vous accompagner vers un mieux-être
              durable et une vitalité retrouvée.
            </p>
            <Link to="/booking" className="btn btn-cta">
              Prendre rendez-vous
            </Link>
          </div>
        </div>
      </section>

      {/* Section Témoignages */}
      <section className="testimonials-section">
        <div className="container">
          <div className="section-header">
            <h2>Témoignages</h2>
            <p>Ce que disent nos clients</p>
          </div>
          
          <div className="testimonials-grid">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card">
                <div className="testimonial-rating">
                  {[...Array(5)].map((_, i) => (
                    <span
                      key={i}
                      className={`star ${i < testimonial.rating ? 'filled' : ''}`}
                    >
                      ★
                    </span>
                  ))}
                </div>
                <div className="testimonial-content">"{testimonial.content}"</div>
                <div className="testimonial-author">{testimonial.name}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section CTA */}
      <section className="cta-section">
        <div className="container">
          <h2>Prêt à retrouver votre équilibre naturel ?</h2>
          <p>Réservez votre consultation dès maintenant</p>
          <Link to="/booking" className="btn btn-cta">
            Prendre rendez-vous
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;